import MultiFilterOptions from './MultiFilterOptions.component';

export default MultiFilterOptions;